import { render } from "./img-report-detail.vue?vue&type=template&id=95891418&ts=true"
import script from "./img-report-detail.vue?vue&type=script&lang=ts"
export * from "./img-report-detail.vue?vue&type=script&lang=ts"

import "./img-report-detail.vue?vue&type=style&index=0&id=95891418&lang=scss"

import exportComponent from "/srv/bimgx-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__